import $ from 'jquery';

//Accordion
$(function() {	
	$('.select-menu-t3').on('change', function() {	
		var selectedval = $(this).find(":selected").val();	
		if(selectedval != "" && selectedval != undefined){			
			window.location.href = String(selectedval);
		}
	});
});